import React, { useState, useCallback } from 'react';
import { Box, Button } from '@mui/material';
import SiteSelectionDialog from '../SiteSelectionDialog/SiteSelectionDialog';
import EmptyState from '../EmptyState/EmptyState';
import { Devices as DevicesIcon } from "@mui/icons-material";
import { useVrsTranslationState } from '../../context/AppContext/AppContext';

interface EmptyStateActionsProps {
    activeCompanyId: string;
    selectSiteButtonText: string;
    showSelectSite?: boolean;
}

export const EmptyStateActions: React.FC<EmptyStateActionsProps> = ({
    activeCompanyId,
    selectSiteButtonText,
    showSelectSite = true,
}) => {
    const [showSiteSelectionDialog, setShowSiteSelectionDialog] = useState(false);
    const { _T } = useVrsTranslationState();

    const handleSiteSelectionNavigation = useCallback(() => {
        setShowSiteSelectionDialog(true);
    }, []);

    const onCloseSiteSelectionDialog = useCallback(() => {
        setShowSiteSelectionDialog(false);
    }, []);

    const shouldShowSelectSite = showSelectSite && activeCompanyId === "0";

    return <><EmptyState
        title={activeCompanyId !== "0" ? _T("No Devices Found") : _T("No Site Selected")}
        description={activeCompanyId !== "0" ? "" :
            _T("Use the link below to select a site.")
        }
        icon={<DevicesIcon sx={{ fontSize: '2.5rem', color: 'grey.500' }} />}
    />

        {shouldShowSelectSite && (
            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSiteSelectionNavigation}
                >
                    {selectSiteButtonText}
                </Button>
            </Box>
        )}

        {showSiteSelectionDialog && (
            <SiteSelectionDialog
                open={showSiteSelectionDialog}
                onClose={onCloseSiteSelectionDialog}
            />
        )}
    </>

};

export default EmptyStateActions;